import React, { Component, PropTypes } from 'react'
import qs from 'qs'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import resourceTypes from './reservationTypes'

import api from '../../../api'

class OrderSelect extends Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      selectedOrderId: null,
      orders: []
    }
  }

  /**
   * Refresh selectable orders when account changes
   */

  componentDidMount () {
    api.get(`admin/orders?${qs.stringify({
      filters: { order_status: ['open'] }
    })}`)
      .then(res => res.json())
      .then(orders => this.setState({ orders }))
  }

  handleSelection = (e, index, selectedOrderId) => {
    if (index === -1) {
      return
    }
    this.setState({ selectedOrderId })
    this.props.onChange(null, selectedOrderId)
  }

  render () {
    const { orders, selectedOrderId } = this.state
    const { resource } = this.props

    return (
      <SelectField
        floatingLabelText='Order'
        value={selectedOrderId}
        onChange={this.handleSelection}
        disabled={
          !resource.type ||
          (resource.type === resourceTypes.user && !resource.user_id) ||
          (resource.type === resourceTypes.institution && !resource.institution_id)
        }
      >
        {orders.map(order => (
          <MenuItem key={order.id} value={order.id} primaryText={order.description} />
        ))}
      </SelectField>
    )
  }
}

// @ts-ignore
OrderSelect.propTypes = {
  sessionSaleId: PropTypes.number.isRequired
}

export default OrderSelect
